import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import DashboardNestRoutes from '../routes/DashboardRoutes';
import _constantUtil from '../../utils/Constant';
import Offline from '../Offline';
import QuotationRuotes from '../routes/QuotationRuotes';
import VendorRoutes from '../routes/VendorRoutes';
import ProfileRoutes from '../routes/ProfileRoutes';
import PasswordRoutes from '../routes/PasswordRoutes';

const {
    BOOLEAN_FALSE: falseValue,
} = _constantUtil;

function Appmain() {
    const buttonRef = useRef(null);
    const htmlRef = useRef(document.documentElement);
    const [isBackdropVisible, setIsBackdropVisible] = useState(falseValue);
    const [isSidebarVisible, setIsSidebarVisible] = useState(falseValue);
    const location = useLocation();
    const [isOffline, setIsOffline] = useState(!navigator.onLine);

 

    useEffect(() => {
        const handleButtonClick = () => {
            if (window.innerWidth < 992) {
                document.body.classList.toggle('sidebar-enable');
            } else {
                document.body.classList.toggle('vertical-collpsed');
            }
            setIsBackdropVisible(!isBackdropVisible);
        };

        const handleClickOutside = (event) => {
            if (
                window.innerWidth <= 1200 &&
                !buttonRef.current.contains(event.target) &&
                !document.body.classList.contains('sidebar-enable') &&
                !event.target.closest('.sidebar-enable')
            ) {
                document.body.classList.remove('sidebar-enable');
                if (window.innerWidth >= 992) {
                    document.body.classList.remove('vertical-collpsed');
                }
                setIsBackdropVisible(false);
            }
        };

        const buttonElement = buttonRef.current;
        if (buttonElement) {
            buttonElement.addEventListener('click', handleButtonClick);
        }

        document.addEventListener('click', handleClickOutside);

        return () => {
            if (buttonElement) {
                buttonElement.removeEventListener('click', handleButtonClick);
            }
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isBackdropVisible]);

    // 👇 New useEffect: Close sidebar on route change (for mobile)
    useEffect(() => {
        if (window.innerWidth < 992) {
            document.body.classList.remove('sidebar-enable');
            setIsBackdropVisible(false);
        }
    }, [location]);

    //* sidebar toggle
    useEffect(() => {
        const outClick = (event) => {
            if (isSidebarVisible && !htmlRef.current.contains(event.target)) {
                setIsSidebarVisible(falseValue);
                htmlRef.current.classList.remove('sidebar-enable');
            }
        };

        document.addEventListener('click', outClick);

        return () => {
            document.removeEventListener('click', outClick);
        };
    }, [isSidebarVisible]);

    // * handle offline
    useEffect(() => {
        const handleOnline = () => setIsOffline(false);
        const handleOffline = () => setIsOffline(true);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // * cleanup listeners when component unmounts
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <>
            {
                isOffline ?
                    <Offline />
                    :
                    <>
                        <div className='layout-wrapper'>
                            <Header buttonRef={buttonRef} />
                            <Sidebar isSidebarVisible={isSidebarVisible} />
                            <div className='main-content'>
                                <DashboardNestRoutes />
                                <QuotationRuotes />
                                <VendorRoutes />
                                <ProfileRoutes />
                                <PasswordRoutes />
                                <Footer />
                            </div>
                        </div>
                    </>
            }
        </>
    );
}

export default Appmain; 